'use client'

import { type FC, Suspense } from 'react'

import dynamic from 'next/dynamic'

import { ChatContextProvider } from '@contexts/chat.context'

const Chat = dynamic(() => import('@components/chat'), { ssr: false })

const withChat = <T extends Record<string, unknown>>(
  WrappedComponent: FC<T>,
): ((props: T & { isResetPasswordChat?: boolean }) => JSX.Element) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const ComponentWithChat = (props: T & { isResetPasswordChat?: boolean }): JSX.Element => (
    <ChatContextProvider>
      <Suspense>
        <Chat isResetPasswordChat={props.isResetPasswordChat} />
      </Suspense>
      <WrappedComponent {...props} />
    </ChatContextProvider>
  )

  ComponentWithChat.displayName = `withChat(${displayName})`

  return ComponentWithChat
}

export default withChat
